import { useHistory } from "react-router-dom";
import { t } from "@/i18n-js/instance";
import { SettingsHeader } from "@/react/components/SettingsApp/SettingsHeader";
import { usePlanStatus } from "@/react/hooks/usePlanStatus";
import { usePunditUserContext } from "@circle-react/contexts";
import { communityBillingPath } from "@circle-react/helpers/urlHelpers";
import { Button } from "@circle-react-uikit/Button";
import { SettingsContainer } from "../../SettingsContainer";
import { Plans } from "./Plans";
import { PlansProvider } from "./PlansContext";

interface RegularPlanProps {
  isExpired: boolean;
}

// All plans different than Plus as Basic, Professional, Enterprise and Business
export const RegularPlan = ({ isExpired }: RegularPlanProps) => {
  const history = useHistory();
  const { currentCommunity } = usePunditUserContext();
  const { isPromoCodeEnabledForCommunity } = usePlanStatus();
  const shouldSeeBillingTab =
    currentCommunity?.subscription && !currentCommunity?.subscription_cancelled;

  const getSettingsContainerMaxWidth = () => {
    if (
      currentCommunity?.subscription_cancelled ||
      isPromoCodeEnabledForCommunity
    ) {
      return "lg";
    }
    return "none";
  };

  const settingsContainerMaxWidth = getSettingsContainerMaxWidth();

  return (
    <>
      <SettingsHeader
        pageTitle={t("pricing_plans.title")}
        layoutConfigProps={{
          key: isExpired,
          disableRightSidebar: true,
          disableSidebar: isExpired,
        }}
        rightContent={
          shouldSeeBillingTab && (
            <Button
              variant="secondary"
              onClick={() => history.push(communityBillingPath())}
            >
              {t("pricing_plans.manage_billing")}
            </Button>
          )
        }
      />
      <SettingsContainer
        className="bg-primary md:bg-inherit md:!p-0"
        maxWidth={settingsContainerMaxWidth}
      >
        <PlansProvider>
          <Plans />
        </PlansProvider>
      </SettingsContainer>
    </>
  );
};
